<template>
    <div id="user-management">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', href: '/' },
                { text: 'Tryout Members' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Tryout Members</h3>

        <v-card>
            <v-card-title>
                Daftar Tryout Members
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider />
            <app-datatable
                :items="groups"
                :headers="headers"
                :has-custom-pagination="true"
                :custom-pagination-current-page="pageNumber"
                :custom-pagination-per-page="10"
                v-on:dblClicked="goToDetail"
                v-on:changePage="pageNumber = $event"
                v-on:doSearch="
                    query = $event;
                    loadUserData();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import axios from "axios";
import DataTable from "@/modules/global/components/plugins/DataTable-s";
import Moment from "moment";

export default {
    name: "tryout-group-management",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            query: "",
            isLoading: false,
            pageNumber: 1,
            groups: [],
            headers: [
                { text: "No.", value: "no", width: 70 },
                { text: "Nama Tryout Group", value: "name", width: 250 },
                { text: "Tipe", value: "type", width: 170 },
                { text: "Kelas", value: "grade", width: 150 },
                { text: "Jumlah Tryout", value: "tryouts.length", width: 150 },
                { text: "Tanggal Mulai", value: "opened_at", width: 150 },
                { text: "Tanggal Selesai", value: "closed_at", width: 150 },
            ],
        };
    },

    watch: {
        pageNumber: function (newVal) {
            this.loadUserData(newVal);
        },
    },

    methods: {
        loadUserData: function (pageNumber = 1) {
            var context = this;
            var token = this.$ls.get("token");
            var url = process.env.API_BASE_URL + "tryout-service/tryout_groups";

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url, {
                params: {
                    page: pageNumber,
                    search_by: "name",
                    search: this.query,
                },
            })
                .then(function (response) {
                    response.data.tryout_groups.forEach((group) => {
                        var data = group;
                        data.opened_at = Moment(data.opened_at).format(
                            "YYYY-MM-DD",
                        );
                        data.closed_at = Moment(data.closed_at).format(
                            "YYYY-MM-DD",
                        );
                        context.groups.push(data);
                    });
                    // context.groups = response.data;
                    context.groups = response.data.tryout_groups;
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        goToDetail: function (index) {
            this.$router.push("tryout-members/" + this.groups[index].id);
        },
    },

    mounted: function () {
        this.loadUserData();
    },
};
</script>



// WEBPACK FOOTER //
// TryoutMembers.vue?2fec1f9e